module.exports = __webpack_public_path__ + "img/icon-13.565533aa.png";